module.exports = __webpack_public_path__ + "img/liam.c1313251.jpg";